import { render } from "./SupportDocumentation.vue?vue&type=template&id=59752aca&scoped=true"
import script from "./support_documentation.js?vue&type=script&lang=js&external"
export * from "./support_documentation.js?vue&type=script&lang=js&external"

import "./SupportDocumentation.vue?vue&type=style&index=0&id=59752aca&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59752aca"]])

export default __exports__